import { useMutation } from '@tanstack/react-query';
import type {
  CreateCardTemplateRequestDto,
  CreateCardTemplateResponseDto,
} from '../../model';
import { createCardTemplate } from '../requests';

interface Options {
  onSuccess?: (data: CreateCardTemplateResponseDto) => void;
  onError?: (error: Error) => void;
}

export function useCreateCardTemplate({ onSuccess, onError }: Options = {}) {
  const mutation = useMutation<
    CreateCardTemplateResponseDto,
    Error,
    CreateCardTemplateRequestDto
  >({
    mutationFn: args => createCardTemplate(args),
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
